import React, { useCallback, useMemo, useState } from 'react';
import { Layout, Seo } from '@layout';
import { GalleryPageContent, ProcessFilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContent';
import { designsCanonicalUrl } from '@utils/gallery.util';
import { graphql } from 'gatsby';
import { FilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContentFiltering';
import { useTranslation } from 'react-i18next';
import { useProcessDesignCards } from '@utils/joyDesign.utils';
import { insertNewTemplates, processDesignFilterGroups } from '@utils/designTemplates';

export const query = graphql`
  {
    bliss {
      stationeryTemplatesContainer(filter: { categories: [saveTheDate, invitation] }) {
        pagedResults {
          edges {
            node {
              themeId
              thumbnailUrl
              approved
              enabled
              category
            }
          }
        }
      }
      themeVariants(variantTypes: [aloha, brannan]) {
        variationType
        imageUrl
        printUrl
        vendor
        tags
        colors
        font
        variantColor
        variantName
        variantThemeId
        theme {
          id
          name
          themeId
          marketingData {
            variationType
            imageUrl
            printUrl
            vendor
            tags
            colors
            font
            variantColor
            variantName
            variantThemeId
            theme {
              name
              themeId
            }
          }
        }
      }
    }
  }
`;

const page: MarcomPageName = 'wedding-website';

const placeThemeAtPosition = (cards: MarketingData, themeId: string, position: number): MarketingData => {
  const targetIndex = cards.findIndex((card) => card.theme.themeId === themeId && card.variationType === 'aloha');

  if (targetIndex !== -1) {
    const cardsCopy = Array.from(cards);
    const [targetCard] = cardsCopy.splice(targetIndex, 1);

    return [...cardsCopy.slice(0, position), targetCard, ...cardsCopy.slice(position)];
  }

  return cards;
};

const WeddingInvitationsDesigns = ({ data }: { data: BlissGalleryECardsThemesData }) => {
  const { cards } = useProcessDesignCards(data);

  const [chromeless, setChromeless] = useState(false);

  const processFilterGroups = useCallback<ProcessFilterGroups>(processDesignFilterGroups, []);

  const { t } = useTranslation('designs');
  const seo = t('seo');
  const designs = t('productTypes.designs', { ns: 'galleryPage' });

  const handleSortCards = useCallback((cards: MarketingData) => {
    return insertNewTemplates(cards);
  }, []);

  return (
    <Layout
      isTransparentHeader={true}
      transparentJoyLogoColor="purple6"
      transparentHeaderButtonVariant="primary"
      transparentHeaderLinkVariant="navLink"
      page={page}
      chromeless={chromeless}
    >
      <Seo title={seo.title} description={seo.content} canonicalURL={designsCanonicalUrl} ogImage={'common/meta_share/invites.jpg'} />
      <GalleryPageContent
        page={page}
        productType="Wedding Website"
        cards={cards}
        processFilterGroups={processFilterGroups}
        showModal={(isModalOpened) => {
          setChromeless(isModalOpened);
        }}
        sortCards={handleSortCards}
      />
    </Layout>
  );
};

export default WeddingInvitationsDesigns;
